import { Constants } from "./constants";

export class PageTemplates {
    public contentDocIds: Array<String> = new Array<String>();
    public type: String = 'pageTemplates';
    public _id: String = Constants.USER + '.pageTemplates';
    public owner: String = Constants.USER;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/pageTemplates.ts